import { useAuthStatus } from "@domain/auth/useAuth";

export function AuthInitializer({ children }: { children: React.ReactNode }) {
  useAuthStatus();

  return <>{children}</>;
}
